import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import Handoff from './views/auth/Handoff';
import { ChakraProvider } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { AuthProvider, useAuth } from 'lib/auth';

function Gate({ theme, setTheme }) {
  const { account, loading } = useAuth();
  if (loading) return null;
  return (
    <Routes>
      <Route path="handoff" element={<Handoff />} />
      <Route path="auth/*" element={account ? <Navigate to="/admin" replace /> : <AuthLayout />} />
      <Route path="admin/*" element={account ? <AdminLayout theme={theme} setTheme={setTheme} /> : <Navigate to="/auth/sign-in" replace />} />
      <Route path="/" element={<Navigate to={account ? '/admin' : '/auth/sign-in'} replace />} />
    </Routes>
  );
}

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
      <AuthProvider>
        <Gate theme={currentTheme} setTheme={setCurrentTheme} />
      </AuthProvider>
    </ChakraProvider>
  );
}
